import $ from 'jquery';
import 'jquery.cookie';
import axios from 'axios';
import moment_tz from 'moment-timezone';

let CryptoJS = require('crypto-js');
let detector = require('detector');
const uuidV1 = require('uuid');

export default {
  get: function (url, options, headers) {
    if (options === undefined) {
      options = { async: true };
    } else if (typeof options === 'boolean') {
      options = { async: options };
    }

    return this.call(url, 'GET', options, headers);
  },
  post: function (url, args, options, headers) {
    if (options === undefined) {
      options = { async: true };
    } else if (typeof options === 'boolean') {
      options = { async: options };
    }
    return this.call(url, 'POST', options, args, headers);
  },
  put: function (url, args, options, headers) {
    if (options === undefined) {
      options = { async: true };
    } else if (typeof options === 'boolean') {
      options = { async: options };
    }
    return this.call(url, 'PUT', options, args, headers);
  },
  delete: function (url, args, options, headers) {
    if (options === undefined) {
      options = { async: true };
    } else if (typeof options === 'boolean') {
      options = { async: options };
    }
    return this.call(url, 'DELETE', options, args, headers);
  },
  patch: function (url, args, options, headers) {
    if (options === undefined) {
      options = { async: true };
    } else if (typeof options === 'boolean') {
      options = { async: options };
    }
    return this.call(url, 'PATCH', options, args, headers);
  },
  call: function (url, method, options, args, headers) {
    let target = this;
    let xmlReq;

    try {
      xmlReq = new Promise(function (resolve, reject) {
        let transactionId = target.getTransactionId();

        // let manilaTime = moment_tz
        //   .tz(new Date(), 'Asia/Manila')
        //   .format('YYYY-MM-DD HH:mm:ss');

        let diffTime = localStorage.getItem('diff-time');

        let ts = moment_tz().add(-diffTime, 's').format('YYYYMMDDHHmmss');

        let authorization = $.cookie('authorization');

        if (authorization) {
          const send = axios.create({
            timeout: 180000,
            headers: {
              'Content-type': 'application/json;',
              Accept: '*/*',
              Authorization: 'Bearer ' + authorization,
              TransactionID: transactionId,
              Datetime: ts,
              //   'ip': ,
              OS: detector.os.name,
              Browser: target.getBrowser(),
            },
          });
          //signature
          if (authorization !== undefined) {
            let hash_key = authorization;
            // hash_key = CryptoJS.SHA256((hash_key+ts).toString(CryptoJS.enc.Utf8), hash_key).toString(CryptoJS.enc.Base64);
            let signature = CryptoJS.enc.Base64.stringify(
              CryptoJS.HmacSHA256(transactionId + Number(ts), hash_key)
            );
            send.defaults.headers = {
              ...send.defaults.headers,
              Signature: signature,
            };
          }
          if (headers !== undefined) {
            send.defaults.headers = {
              ...send.defaults.headers,
              ...headers,
            };
          }
          send({
            url: url,
            method: method,
            data: args,
          })
            .then((response) => {
              if (response.status >= 200 && response.status < 300) {
                resolve(response);
              }
              // TODO: else 로직 타는지 확인필요
              else {
                reject(response);
              }
            })
            .catch((error) => {
              //인증권한 없음/세션만료
              if (error.response) {
                console.log(error.response);
                if (error.response.status === 401) {
                  console.error('API_ERROR_02 : Session expired.');
                  //세션 만료 후 로그인 페이지 전환

                  var cookies = $.cookie();
                  for (var cookie in cookies) {
                    $.removeCookie(cookie);
                  }

                  sessionStorage.clear();

                  // window.location.reload();
                  //TODO: 401 처리해야함
                  window.location.href = '/#/account/signIn';
                  reject(error.response);
                } else {
                  resolve(error.response);
                }
              }
              //요청 했으나 응답 없음
              else if (error.request) {
                console.error(
                  'API_ERROR_03 : Requested but no response from server.'
                );
                reject(error.request);
              }
              //요청 설정 중 문제 발생
              else {
                console.error('API_ERROR_01 : Error requesting API.');
                reject(error.request);
              }
            });
        } else {
          // 로그인 인증 키값 없을시 > 추가 수정 필요
          // console.log('로그인이 필요 메뉴 입니다.');
          window.location.href = '/#/account/signIn';
          resolve({ status: 400 });
        }
      });
    } catch (error) {
      console.error('API_ERROR_00 : API error occurred.');
    }
    return xmlReq;
  },

  getLocation: function (url) {
    let match = url.match(
      /^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/
    );
    return (
      match && {
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7],
      }
    );
  },
  getService: function (url) {
    let service = '';
    if (url.split('/').length > 2) {
      service = url.split('/')[3];
    }
    return service;
  },
  getTransactionId: function () {
    let randomstring = '';
    randomstring = uuidV1.v1().replace(/-/g, '');
    return randomstring;
  },
  setEncodeUrl: function (url) {
    if (url.search('\\?') == -1) return url;
    //search = /([^&=]+)=?([^&]*)/g,     원복 시 search만 변경하면 됩니다.
    let match,
      pl = /\+/g,
      search = /([^&=]+)=?(.*?(?=[&?]\w+=|$))/g,
      //decode = function (s) { return encodeURIComponent(s.replace(pl, " ")); },
      decode = function (s) {
        return encodeURIComponent(s.replace(/[!'()*]/g, escape));
      },
      query = this.getLocation(url).search;
    if (query.search('\\?') == 0) query = query.substring(1, query.length);

    let urlstr = url.substring(0, url.search('\\?') + 1);
    while ((match = search.exec(query))) {
      urlstr += match[1] + '=' + decode(match[2]) + '&';
    }
    if (urlstr.substring(urlstr.length - 1, urlstr.length) == '&')
      urlstr = urlstr.substring(0, urlstr.length - 1);
    return urlstr;
  },

  getBrowser: function () {
    let agent = navigator.userAgent.toLowerCase();
    let name = navigator.appName;
    let browser = '';

    if (
      name === 'Microsoft Internet Explorer' ||
      agent.indexOf('trident') > -1 ||
      agent.indexOf('edge/') > -1
    ) {
      browser = 'IE';
      if (name === 'Microsoft Internet Explorer') {
        // IE old version (IE 10 or Lower)
        agent = /msie ([0-9]{1,}[\.0-9]{0,})/.exec(agent);
        browser += parseInt(agent[1]);
      } else {
        // IE 11+
        if (agent.indexOf('trident') > -1) {
          // IE 11
          browser += 11;
        } else if (agent.indexOf('edge/') > -1) {
          // Edge
          browser = 'Edge';
        }
      }
    } else if (agent.indexOf('safari') > -1) {
      // Chrome or Safari
      if (agent.indexOf('opr') > -1) {
        // Opera
        browser = 'Opera';
      } else if (agent.indexOf('chrome') > -1) {
        // Chrome
        browser = 'Chrome';
      } else {
        // Safari
        browser = 'Safari';
      }
    } else if (agent.indexOf('firefox') > -1) {
      // Firefox
      browser = 'Firefox';
    }

    return browser;
  },
};
